










































































































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
import { virtualMachineDetailsService } from '@/components/virtual-machine-edit/services/VirtualMachineDetailsService';
import { mapState } from 'vuex';
import { pricesService } from '@/services/PricesService';
import { currencyService } from '@/services/CurrencyService';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';
import EventBus from '@/EventBus';

@Component({
  components: {
    PriceWithCurrency,
  },
  props: ['virtualMachine', 'orginalDescription'],
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class VirtualMachineActions extends Vue {
  workspaceId = 0;
  regionId = 0;
  virtualMachineId = 0;
  isEditingDescriptionHidden = true;
  isRemoveModalShown: boolean = false;
  isConsoleAccessModalShown: boolean = false;
  consoleAccessDescription: any = '';
  errors: any = [];
  isLoading: boolean = false;
  isConsoleAccessLimitExceeded: boolean = false;
  isConsoleAccessGrantingFailed: boolean = false;
  insufficientPermissions: boolean = false;
  openBackupModal: boolean = false;
  currency: string = '';
  VMbackupPrice: any = {};
  backupStorage: any = {};
  priceModifier = 0.00001;
  currentRegion: string = '';
  showContactUsInfo: boolean = false;

  @Watch('$store.state.regions.regions', { immediate: true, deep: true })
  onRegionsChange() {
    this.currentRegion = this.$store.getters['regions/getCurrentRegion'];
  }
  @Emit()
  onStatusChange() {
    return;
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.virtualMachineId = parseInt(this.$route.params.virtualMachineId, 10);
    this.consoleAccessDescription = this.$t('helpForm.descriptions.consoleAccess');
    currencyService.getCurrency(this.workspaceId).then((currency: string) => {
      this.currency = currency;
    });
    pricesService.getPrices(this.workspaceId, this.regionId).then((data: any) => {
      const VM_backup = data.filter((item: any) => item.resource === 'vm_backup' && item.currency === this.currency);
      this.VMbackupPrice = VM_backup[0];
      const backup_storage = data.filter(
        (item: any) =>
          item.resource === 'backup_storage' &&
          item.currency === this.currency &&
          item.cluster_id === this.$props.virtualMachine.cluster_id
      );
      this.backupStorage = backup_storage[0];
    });
    EventBus.$on('backup_activated', () => {
      this.$props.virtualMachine = { ...this.$props.virtualMachine };
    });
  }
  onCloseRemoveModal() {
    this.isRemoveModalShown = false;
  }
  openRemoveModal() {
    if (this.$props.virtualMachine.state === 'busy') {
      return;
    }
    this.isRemoveModalShown = true;
  }
  onCloseConsoleModal() {
    this.isConsoleAccessModalShown = false;
  }
  onCloseConsoleErrorModal() {
    this.isConsoleAccessLimitExceeded = false;
    this.isConsoleAccessGrantingFailed = false;
  }
  editVirtualMachineDescription() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .editVirtualMachineDetails(this.workspaceId, this.regionId, this.virtualMachineId, {
        name: this.$props.virtualMachine.name,
        description: this.$props.virtualMachine.description,
      })
      .then(() => {
        this.isLoading = false;
        this.isEditingDescriptionHidden = true;
        this.$props.orginalDescription = this.$props.virtualMachine.description;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  cancelDescription() {
    this.isEditingDescriptionHidden = !this.isEditingDescriptionHidden;
    this.$props.virtualMachine.description = this.$props.orginalDescription;
  }
  powerOnOff() {
    if (this.$props.virtualMachine.state === 'busy' || this.$props.virtualMachine.state === 'error') {
      return;
    }
    if (this.$props.virtualMachine.state === 'on' || this.$props.virtualMachine.state === 'idle') {
      this.powerOff();
    } else {
      this.powerOn();
    }
  }
  powerOff() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .powerOffVirtualMachine(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.isLoading = false;
        this.onStatusChange();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  powerOn() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .powerOnVirtualMachine(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.isLoading = false;
        this.onStatusChange();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  suspend() {
    if (
      this.$props.virtualMachine.state === 'busy' ||
      this.$props.virtualMachine.state === 'error' ||
      this.$props.virtualMachine.state === 'off' ||
      this.$props.virtualMachine.state === 'suspended'
    ) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .suspendVirtualMachine(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.isLoading = false;
        this.onStatusChange();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  restart() {
    if (
      this.$props.virtualMachine.state === 'busy' ||
      this.$props.virtualMachine.state === 'error' ||
      this.$props.virtualMachine.state === 'off' ||
      this.$props.virtualMachine.state === 'suspended'
    ) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .restartVirtualMachine(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.isLoading = false;
        this.onStatusChange();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  deleteVirtualMachine() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .deleteVirtualMachine(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.isLoading = false;
        this.$router.push(`/workspaces/${this.workspaceId}/regions/${this.regionId}`).catch(() => {});
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  openConsole() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.isConsoleAccessModalShown = false;
    this.isConsoleAccessLimitExceeded = false;
    this.isConsoleAccessGrantingFailed = false;

    virtualMachineDetailsService
      .accessTheConsole(this.workspaceId, this.regionId, this.virtualMachineId)
      .then((data: any) => {
        this.isLoading = false;
        window.open(
          `/console?token=${data.token}&wsUri=${data.url}`,
          `Console ${new Date().getTime()}${Math.floor(Math.random() * 100 + 1)}`,
          'directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=804,height=626'
        );
      })
      .catch(data => {
        this.isLoading = false;
        if (data && data.data && data.status === 403) {
          let error = data.data.error || {};
          if (error === 'console_inaccessible') {
            this.isConsoleAccessModalShown = true;
          }
          if (error === 'console_access_limit_exceeded') {
            this.isConsoleAccessLimitExceeded = true;
          }
        }
        if (data && data.data && data.status === 502) {
          let error = data.data.error || {};
          if (error === 'console_access_granting_failed') {
            this.isConsoleAccessGrantingFailed = true;
          }
        }
      });
  }
  activateBackup() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .activateBackup(this.workspaceId, this.regionId, this.virtualMachineId)
      .then(() => {
        this.isLoading = false;
        this.openBackupModal = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
